<template>
    <div class="drawings-wrap">
        <div id="drawingsmap" class="drawingsmap"></div>
    </div>
</template>

<script>
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import {defaults as interactionDefaluts } from 'ol/interaction';
import {get as getProj } from 'ol/proj';
import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import {createEmpty,extend as Extentd} from 'ol/extent';

import ExtraLayers from "./ExtraLayers"

import {getPipelinelayer} from "@api/map2d";

/**工程图 */
export default {
    name:"drawings",
    data(){
        return {
            drawingsmap:null , // 工程图底图
        }
    },
    mounted(){
        // 加载底图
        this.init_map();
    },
    methods:{
        // 初始化底图
        init_map(){
            let map=new Map({
                logo:false,
                target:"drawingsmap",
                interactions: interactionDefaluts({
                    doubleClickZoom:false
                }),
                view:new View({
                    center: [120.158, 30.267],
                    projection: getProj("EPSG:4326"),
                    zoom: 10,
                    maxZoom: 20,
                    minZoom: 2
                })
            });
            this.drawingsmap=map;
            // 加载管线图层
            this.getPipelinelayer();

            // 加载WMS
            new ExtraLayers(map);
        },
        // 获取管线图层数据
        async getPipelinelayer(){
            let that=this;
            await getPipelinelayer().then(data=>{
                // 判断是否数据正常
                if(data&&data.status&&data.status==500){
                    return
                }
                // 加载管线数据
                let geojsonFormat=new GeoJSON();
                let features=geojsonFormat.readFeatures(data);

                //绘制图层
                let vectorSource = new VectorSource({
                    format: new GeoJSON(),
                });
                vectorSource.addFeatures(features);
                let vector = new VectorLayer({
                    name:"pipeline_layer",
                    source: vectorSource,
                    zIndex:200,
                    style:new Style({
                        stroke: new Stroke({
                            lineCap:"square",
                            width:1,
                            color:"rgb(255, 255, 255)"
                        })
                    })
                });
                // 将图层添加到底图上
                that.drawingsmap.addLayer(vector);

                //获取管线范围
                let extent=createEmpty();
                let featureArray=features;
                for(let i=featureArray.length-1;i>=0;i--){
                    let feature=featureArray[i];
                    //存储图形的范围
                    let geom=feature.getGeometry();
                    extent=Extentd(extent,geom.getExtent());
                }
                //保存图形范围
                that.featureExtent=extent;
                let [x1,y1,x2,y2]=extent;
                that.featureExtent=[x1-0.01,y1-0.01,x2+0.01,y2+0.01];
                //图形缩放到全屏
                that.drawingsmap.getView().fit(that.featureExtent,that.drawingsmap.getSize());
            });
        },
    },
}
</script>

<style lang="scss">
.drawings-wrap{
    width:100%;
    height:100%;

    .drawingsmap{
        width: 100%;
        height: 100%;
        background: #000;
    }
}
</style>